import { useTranslation } from 'react-i18next'
import { CategoryArchive } from '@/components/sections'
import type { Line } from '@/data/products'

const lineOrder: Line[] = ['face']

export function CategoryVisoPage() {
  const { t } = useTranslation('common')
  return (
    <CategoryArchive
      category="face"
      lineOrder={lineOrder}
      hero={{
        eyebrow: t('categoryViso.hero.eyebrow'),
        title: t('categoryViso.hero.title'),
        titleItalic: t('categoryViso.hero.titleItalic'),
        intro: t('categoryViso.hero.intro'),
        image: '/images/categories/viso-hero.jpg',
        imageAlt: t('categoryViso.hero.imageAlt'),
      }}
      faq={{
        eyebrow: t('categoryViso.faq.eyebrow'),
        title: t('categoryViso.faq.title'),
        titleItalic: t('categoryViso.faq.titleItalic'),
        body: (
          <>
            <p>{t('categoryViso.faq.bodyParagraph1')}</p>
            <p>
              <strong className="text-bruno">{t('categoryViso.faq.bodyQuestion')}</strong>{' '}
              {t('categoryViso.faq.bodyParagraph2')}
            </p>
          </>
        ),
      }}
      labels={{
        filterByLine: t('categoryViso.archiveLabels.filterByLine'),
        scrollLeft: t('categoryViso.archiveLabels.scrollLeft'),
        scrollRight: t('categoryViso.archiveLabels.scrollRight'),
        all: t('categoryViso.archiveLabels.all'),
        linePrefix: t('categoryViso.archiveLabels.linePrefix'),
        productsSuffix: t('categoryViso.archiveLabels.productsSuffix'),
        defaultEyebrow: t('categoryViso.archiveLabels.defaultEyebrow'),
        defaultFaqEyebrow: t('categoryViso.archiveLabels.defaultFaqEyebrow'),
        categoryAriaLabel: t('categoryViso.hero.ariaLabel'),
      }}
    />
  )
}
